import { useState } from "react";

import { useDestinationConfigAtRouteId } from "@/destinations/hooks/useDestinationConfigAtRouteId";
import { DestinationConfigRow } from "../ConfigPageRow";
import { IdentityResolutionConfigModal } from "./IdentityMatchingConfigModal";
import { SaaSDestination } from "@/destinations/destinations";

type IdentityMatchingRowProps = {
  destination: SaaSDestination;
};

export function IdentityMatchingRow({ destination }: IdentityMatchingRowProps) {
  const destinationConfig = useDestinationConfigAtRouteId();
  const [modalOpen, setModalOpen] = useState(false);

  if (!destinationConfig) return null;

  const enabled = destinationConfig.settings.identityMatchingEnabled;

  // The `MetaOAuth.tsx` component is used for both the Meta Audiences
  // destination, and for the Meta Insights destination. Identity matching
  // is only relevant for the audiences destination.
  if (!destination.destinationCategories.includes("Audiences")) {
    return null;
  }

  return (
    <>
      <IdentityResolutionConfigModal
        open={modalOpen}
        close={() => setModalOpen(false)}
        destination={destinationConfig}
      />
      <DestinationConfigRow
        name="Automatic identity matching"
        labelText={enabled ? "Enabled" : "Disabled"}
        onOpenConfigModal={() => setModalOpen(true)}
      />
    </>
  );
}
